import React from 'react';
import { SectionContainer } from '../../styles';
import { Box, Text, Title, VerticalBox } from '../../../../components';
import { TeamDeliverables as TeamDeliverablesType } from '../../../../services/about-us/fetchAboutUsPageContent';
import { COLORS, device, FONTS } from '../../../../constants';
import styled from 'styled-components';
import { TeamDeliverablesCard } from './TeamDeliverablesCard';
import { getServiceIcons } from '../../data';
import { MotionText } from '../../../../components/Motion';

interface TeamDeliverablesProps {
  teamDeliverables: TeamDeliverablesType;
}

const TeamDeliverables = ({ teamDeliverables }: TeamDeliverablesProps) => {
  const serviceIcons = getServiceIcons();
  return (
    <SectionContainer $color={COLORS.GRAY_BG_COLOR}>
      <Box>
        <VerticalBox>
          <TeamDeliverablesTextWrapper>
            <Title
              fontFamily={FONTS.TITLE}
              size={36}
              lineHeight={54}
              color={COLORS.SECTION_TITLE}
              title={teamDeliverables.Title}
            />
            <Text
              text={teamDeliverables.Subtitle}
              fontFamily={FONTS.SUBTITLE}
              size={22}
              lineHeight={33}
              color={COLORS.SECTION_TEXT}
            />
          </TeamDeliverablesTextWrapper>
          <TeamDeliverablesContainer>
            {teamDeliverables.Cards.map(item => (
              <TeamDeliverablesCard
                key={item.id}
                card={item}
                icon={serviceIcons[item.Icon]}
              />
            ))}
          </TeamDeliverablesContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};
const TeamDeliverablesTextWrapper = styled(MotionText)`
  display: flex;
  flex-direction: column;
  gap: 60px;
  h4 {
    max-width: 50%;
  }
  @media screen and ${device.lg} {
    gap: 40px;
    h4 {
      max-width: 70%;
      font-size: 20px;
      line-height: 1.5;
    }
  }
  @media screen and ${device.sm} {
    gap: 20px;
    h4 {
      font-size: 15px;
    }
  }
`;

const TeamDeliverablesContainer = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 60px;
  row-gap: 40px;
  @media screen and ${device.lg} {
    gap: 40px;
  }
  @media screen and ${device.md} {
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
  }
`;
export { TeamDeliverables };
